import React, { useEffect } from 'react';
export function RobotsTxt() {
  useEffect(() => {
    const content = `User-agent: *
Allow: /

Sitemap: https://ibizaprivatedrivers.com/sitemap.xml`;
    document.open('text/plain');
    document.write(`<pre>${content}</pre>`);
    document.close();
  }, []);
  return null;
}